import { localization as l } from "@/lib/localization";
import { Connection, WidgetError } from "@/lib/types";

type Props = {
    conn: Connection;
    error: null | WidgetError;
    hasMessages: boolean;
};

function MessageError({ conn, error, hasMessages }: Props): JSX.Element {
    if (!error || !hasMessages || conn.status !== "DownWithError") {
        return <></>;
    }
    switch (error.type) {
        case "FailedToConnect_ClosedConversation":
            return MessageErrorClosedConversation();
        default:
            return (
                <div className="tw-mt-8 tw-w-full tw-rounded tw-border tw-border-solid tw-border-dpj-copper-orange/15 tw-bg-dpj-copper-orange/5 tw-p-4 tw-pb-0">
                    <h6>
                        We are sorry.. <br />
                        We encountered an error.
                    </h6>
                    <ul className="tw-ps-6">
                        <li className="tw-pb-1">Try starting a new chat or..</li>
                        <li className="tw-pb-1">Try refreshing the page or..</li>
                        <li className="tw-pb-1">
                            Contact us through another channel. (link at the bottom
                            of the page.)
                        </li>
                    </ul>
                    <div className="error-hint tw-ml-auto tw-min-h-4 tw-w-fit tw-pr-1 tw-text-[10px]">
                        <code className="tw-text-gray-400">
                            error: {error?.type}
                        </code>
                    </div>
                </div>
            );
    }
}

function MessageErrorClosedConversation(): JSX.Element {
    return (
        <div className="tw-w-full tw-rounded tw-border tw-border-solid tw-border-dpj-forest-green/15 tw-bg-dpj-forest-green/5 tw-p-4 tw-pb-0" >
            <h6>
                {l["This conversation was closed."]}
            </h6>
            <p>
                {l["If you want any further assistance, please start a new chat."]}
            </p>
        </div >
    );

}
export { MessageError };
